export default "__VITE_ASSET__a3b36c24__"